import React from "react";

export function LineSeparator(): JSX.Element {
  return <hr className="my-4xl border-solid border border-muted" />;
}
